import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscMovieCard.module.scss";
import AscTag from "../../AscTag/AscTag";
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);

export interface AscMovieCardProps {
  title?: string;
  coverImageUrl?: string;
  duration?: string;
  className?: string;
  genre?: string;
  loading?: boolean;
}

export default function AscMovieCard({
  title,
  coverImageUrl,
  duration,
  genre,
  className,
  loading = false,
}: AscMovieCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      title={title}
      loading={loading}
      imageClassName={styles.cardImage}
      coverImageUrl={coverImageUrl}
      // tags={[<AscTag label={duration} type="event" />]}
      tagsContainerClassName={styles.tagsContainer}
      contentClassName={styles.cardContent}
      data-testid={"asc-movie-card"}
    >
      {genre}
    </AscGenericCard>
  );
}
